import type { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

import cn from '@/lib/utils/cn';

type Props = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export default function OnesuranceIcon({ className }: Props) {
  return (
    <>
      <img
        src="/assets/onesurance-light.png"
        alt="Onesurance"
        className={cn('inline size-4 shrink-0 dark:hidden', className)}
      />
      <img
        src="/assets/onesurance-dark.png"
        alt="Onesurance"
        className={cn('hidden size-4 shrink-0 dark:inline', className)}
      />
    </>
  );
}
